import { BasePageComponent } from '@/components/base/BasePageComponent';
import { AppConfigService } from '@/services/app-config.service';
import { NavService } from '@/services/nav.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RealProperty } from '@eemo/api-client';
import { PropertySharesComponent } from '../../../views/property/property-shares/property-shares.component';

@Component({
    selector: 'app-prop-shares-page',
    templateUrl: './prop-shares-page.component.html',
    styleUrls: ['./prop-shares-page.component.scss'],
    standalone: true,
    imports: [PropertySharesComponent]
})
export class PropSharesPageComponent extends BasePageComponent implements OnInit {
  prop: RealProperty;

  constructor(
    private appConfigService: AppConfigService,
    protected route: ActivatedRoute,
    protected navService: NavService
  ) {
    super(route, navService);
  }

  ngOnInit(): void {
    this.prop = this.appConfigService.selectedProp;
  }
}
